import script from "./ShufflePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ShufflePage.vue?vue&type=script&setup=true&lang=js"

import "./ShufflePage.vue?vue&type=style&index=0&id=066e1662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066e1662"]])

export default __exports__